import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import { planService } from '@/services/plan'

export const getPlanCancellationsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.plan.cancellations(),
    queryFn: ({ signal }) => planService.cancellations({ signal }),
  })
